import { render, staticRenderFns } from "./AddWebQuestion.vue?vue&type=template&id=4c514245&"
import script from "./AddWebQuestion.vue?vue&type=script&lang=js&"
export * from "./AddWebQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports